import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { ICodeEditorService } from 'vscode/vscode/vs/editor/browser/services/codeEditorService';
import { score } from 'vscode/vscode/vs/editor/common/languageSelector';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { RawContextKey } from 'vscode/vscode/vs/platform/contextkey/common/contextkey';
import { IContextKeyService } from 'vscode/vscode/vs/platform/contextkey/common/contextkey.service';
import { ILabelService } from 'vscode/vscode/vs/platform/label/common/label.service';
import { IQuickInputService } from 'vscode/vscode/vs/platform/quickinput/common/quickInput.service';
import { ITelemetryService } from 'vscode/vscode/vs/platform/telemetry/common/telemetry.service';

const _moduleId = "vs/workbench/contrib/share/browser/shareService";
const ShareProviderCountContext = ( (new RawContextKey('shareProviderCount', 0, ( localizeWithPath(_moduleId, 0, "The number of available share providers")))));
let ShareService = class ShareService {
    constructor(contextKeyService, labelService, quickInputService, codeEditorService, telemetryService) {
        this.contextKeyService = contextKeyService;
        this.labelService = labelService;
        this.quickInputService = quickInputService;
        this.codeEditorService = codeEditorService;
        this.telemetryService = telemetryService;
        this._providers = ( (new Set()));
        this.providerCount = ShareProviderCountContext.bindTo(this.contextKeyService);
    }
    registerShareProvider(provider) {
        this._providers.add(provider);
        this.providerCount.set(this._providers.size);
        return {
            dispose: () => {
                this._providers.delete(provider);
                this.providerCount.set(this._providers.size);
            }
        };
    }
    getShareActions() {
        return [];
    }
    async provideShare(item, token) {
        const language = this.codeEditorService.getActiveCodeEditor()?.getModel()?.getLanguageId() ?? '';
        const providers = [...( (this._providers.values()))]
            .filter((p) => score(p.selector, item.resourceUri, language, true, undefined, undefined) > 0)
            .sort((a, b) => a.priority - b.priority);
        if (providers.length === 0) {
            return undefined;
        }
        if (providers.length === 1) {
            this.telemetryService.publicLog2('shareService.share', { providerId: providers[0].id });
            return providers[0].provideShare(item, token);
        }
        const items = ( (providers.map((p) => ({ label: p.label, provider: p }))));
        const selected = await this.quickInputService.pick(items, { canPickMany: false, placeHolder: ( localizeWithPath(
            _moduleId,
            1,
            'Choose how to share {0}',
            this.labelService.getUriLabel(item.resourceUri)
        )) }, token);
        if (selected !== undefined) {
            this.telemetryService.publicLog2('shareService.share', { providerId: selected.provider.id });
            return selected.provider.provideShare(item, token);
        }
        return;
    }
};
ShareService = ( (__decorate([
    ( (__param(0, IContextKeyService))),
    ( (__param(1, ILabelService))),
    ( (__param(2, IQuickInputService))),
    ( (__param(3, ICodeEditorService))),
    ( (__param(4, ITelemetryService)))
], ShareService)));

export { ShareProviderCountContext, ShareService };
